import React from 'react';
import { FadeIn } from './FadeIn';
import { Star } from 'lucide-react';
export function TestimonialsSection() {
  const testimonials = [{
    name: 'Mariana G.',
    quote: 'Ya no estamos todo el día con el celular. Siento que volví a conectar con mis hijos de verdad.',
    role: 'Mamá de 2'
  }, {
    name: 'Lucía F.',
    quote: 'Mi hijo espera con mucha ilusión abrir una nueva página. ¡Nos unió más de lo que imaginé!',
    role: 'Mamá de 1'
  }, {
    name: 'Paula M.',
    quote: "Desde que empezamos, tenemos nuestro 'momento especial'. Nos reímos muchísimo.",
    role: 'Mamá de 3'
  }];
  return <section className="py-10 bg-white" data-id="element-135" data-mp="182ruuvvqh9x3">
      <div className="container mx-auto px-4" data-id="element-136" data-mp="183t3yut6vmc6">
        <FadeIn data-id="element-137" data-mp="184kzk5msdk2g">
          <h2 className="text-2xl md:text-3xl font-bold text-center text-slate-900 mb-8" data-id="element-138" data-mp="2yfgz0wtjyli4">
            Familias que ya están conectando ❤️
          </h2>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 max-w-6xl mx-auto" data-id="element-139" data-mp="32eon2r202jt7">
          {testimonials.map((testimonial, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-140" data-mp="2q3152lky2u2c" data-mpi={index}>
              <div className="bg-slate-50 p-6 rounded-2xl border border-slate-100 h-full flex flex-col" data-id="element-141" data-mp="2q0exwn1yugkn">
                <div className="flex gap-1 mb-3" data-id="element-142" data-mp="34tgtsackkk59">
                  {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-brand-400 text-brand-400" data-id="element-143" data-mp="2zunb83ife2y8" data-mpi={i} />)}
                </div>
                <p className="text-slate-700 text-base italic mb-4 flex-grow" data-id="element-144" data-mp="275q6z4b1u6oh">
                  "{testimonial.quote}"
                </p>
                <div className="flex items-center gap-3" data-id="element-145" data-mp="2h1a0xl61yval">
                  <div className="w-10 h-10 bg-brand-200 rounded-full flex items-center justify-center text-brand-700 font-bold" data-id="element-146" data-mp="2h3w65e5h0ypn">
                    {testimonial.name.charAt(0)}
                  </div>
                  <div data-id="element-147" data-mp="3sj2oakhzyb6x">
                    <p className="font-bold text-slate-900" data-id="element-148" data-mp="3f0v9mpdo0x0">
                      {testimonial.name}
                    </p>
                    <p className="text-sm text-slate-500" data-id="element-149" data-mp="8cu12emrqswr">{testimonial.role}</p>
                  </div>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}